<template>
  <div class="content">
    <div class="content-main">
      <p class="content-title">新相亲大会</p>
      <div class="content-input">
        <div class="content-input-item">
          <label>性别：</label>
          <el-select v-model="sex" placeholder="Select" style="width: 6.4em">
            <el-option v-for="item in sexArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <label>状态：</label>
          <el-select v-model="state" placeholder="Select" style="width: 6.4em">
            <el-option v-for="item in stateArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <DatePickerRange title="时间：" @date="getTime($event)" @check="getCheck($event)" :isChecked="isChecked"/>
        </div>
<!--        <div class="content-input-item">-->
<!--          <SearchComponents :searchValue="searchValue" @searchType="getSearchType($event)" @searchValue="getSearchValue($event)"/>-->
<!--        </div>-->
        <div class="content-input-item">
          <ElButtons type="primary" icon="search" @click="getPage(true)" :loading="searchLoading"> 查询 </ElButtons>
          <ElButtons icon="RefreshLeft" @click="refreshParam"> 重置 </ElButtons>
        </div>
      </div>
    </div>
    <div class="content-main">
      <div class="content-button">
        <div>
          <el-button type="success" @click="batchUpdate(2)" v-loading="bitchPassLoading">批量通过</el-button>
          <el-button type="danger"  @click="batchUpdate(3)" v-loading="bitchRejectLoading">批量不通过</el-button>
          <el-button type="primary" @click="excel" v-loading="excelLoading">导出</el-button>
        </div>
        <BtnGroup :tableRef="$refs.multipleTableRef" :colList="colList" @colListChange="colListChange($event)" @refresh="getPage"></BtnGroup>
      </div>
      <div class="content-table">
        <el-table
            ref="multipleTableRef"
            :data="pageDataList"
            style="width: 100%"
            v-loading="listLoading"
            @cell-click="toggleSelection"
            @selection-change="selsChange"
            @header-click="selsAll"
            border
        >
          <el-table-column type="selection" width="55" align="center" class-name="cursor"/>
          <el-table-column property="createTime" label="提交时间" v-if="checkColList.indexOf('提交时间') > -1"/>
          <el-table-column property="content" label="用户信息" v-if="checkColList.indexOf('用户信息') > -1" width="160">
            <template #default="scope">
              <p>姓名：{{ scope.row.name }}</p>
              <p>UID：{{ scope.row.resumeInfo.uid }}</p>
              <p>性别：{{ scope.row.sex == 1?'男':scope.row.sex == 2?'女':'' }}</p>
              <p>年龄：{{ scope.row.age }}</p>
              <p>身高：{{ scope.row.height == -1?'145cm以下': scope.row.height == 999?'200cm以上': scope.row.height + 'cm' }}</p>
              <p>体重：{{ scope.row.weight == -1?'35kg以下': scope.row.weight == 999?'100kg以上': scope.row.weight + 'kg' }}</p>
            </template>
          </el-table-column>
          <el-table-column property="phone" label="手机号" v-if="checkColList.indexOf('手机号') > -1"/>
          <el-table-column property="wechatId" label="微信号" v-if="checkColList.indexOf('微信号') > -1"/>
          <el-table-column property="" label="教育背景" v-if="checkColList.indexOf('教育背景') > -1" width="160">
            <template #default="scope">
              <p>学历：{{ educationColumns[scope.row.education -1].label}}</p>
              <p>学校：{{ scope.row.school }}</p>
              <p>专业：{{ scope.row.major }}</p>
            </template>
          </el-table-column>
          <el-table-column property="profession" label="职业" v-if="checkColList.indexOf('职业') > -1"/>
          <el-table-column property="kinsfolkDesc" label="工作地" v-if="checkColList.indexOf('工作地') > -1">
            <template #default="scope">
              <p>{{ scope.row.jobProvince }}</p> {{ scope.row.jobCity }}
            </template>
          </el-table-column>
          <el-table-column property="kinsfolkDesc" label="出生地" v-if="checkColList.indexOf('出生地') > -1">
            <template #default="scope">
              <p>{{ scope.row.birthProvince }}</p> {{ scope.row.birthCity }}
            </template>
          </el-table-column>
          <el-table-column prop="" label="照片" v-if="checkColList.indexOf('照片') > -1" width="200">
            <template #default="scope">
              <el-space wrap>
                <div v-for="(item, index) in scope.row.imgList" :key="item.id" class="imgItem">
                  <el-image style="width: 48px; height: 48px" fit="cover"  :src="item.smallImg" @click="showUploadImg(index, scope.row.imgList)" class="cursor"></el-image>
<!--                  <div class="closeBtn" @click="delImg(item.id, scope.$index, index)">-->
<!--                    <i class="fa fa-times" aria-hidden="true"></i>-->
<!--                  </div>-->
                </div>
<!--                <div v-if="scope.row.imgList.length < 9" @click="addImg(scope.row)" style="width: 60px; height: 60px; border: #ddd dashed 1px; display: flex; align-items: center; justify-content: center; cursor: pointer">-->
<!--                  <ElIcons name="Plus" size="20"/>-->
<!--                </div>-->
<!--                <input type="file" accept=".jp2,.jpe,.jpeg,.jpg,.png" @change="fileChanged" ref="file" multiple="multiple" style="display: none">-->
              </el-space>
            </template>
          </el-table-column>
          <el-table-column prop="" label="父母情况" v-if="checkColList.indexOf('父母情况') > -1" width="200">
            <template #default="scope">
              <el-space wrap>
                <div v-for="(item, index) in scope.row.kinsfolkImgList" :key="item.id" class="imgItem">
                  <el-image style="width: 48px; height: 48px" fit="cover"  :src="item.smallImg" @click="showUploadImg(index, scope.row.kinsfolkImgList)" class="cursor"></el-image>
                  <!--                  <div class="closeBtn" @click="delImg(item.id, scope.$index, index)">-->
                  <!--                    <i class="fa fa-times" aria-hidden="true"></i>-->
                  <!--                  </div>-->
                </div>
                <!--                <div v-if="scope.row.imgList.length < 9" @click="addImg(scope.row)" style="width: 60px; height: 60px; border: #ddd dashed 1px; display: flex; align-items: center; justify-content: center; cursor: pointer">-->
                <!--                  <ElIcons name="Plus" size="20"/>-->
                <!--                </div>-->
                <!--                <input type="file" accept=".jp2,.jpe,.jpeg,.jpg,.png" @change="fileChanged" ref="file" multiple="multiple" style="display: none">-->
              </el-space>
            </template>
          </el-table-column>
          <el-table-column property="kinsfolk" label="参加亲属" v-if="checkColList.indexOf('参加亲属') > -1"/>
          <el-table-column prop="" label="状态" v-if="checkColList.indexOf('状态') > -1">
            <template #default="scope">
              <p>{{ scope.row.state == 1 ? '待审核' : scope.row.state == 2 ? '已通过' : scope.row.state == 3 ? '不通过' : '--' }}</p>
            </template>
          </el-table-column>
          <el-table-column property="remark" label="备注" v-if="checkColList.indexOf('备注') > -1" class-name="cursor"/>
<!--          <el-table-column label="用户日志" v-if="checkColList.indexOf('用户日志') > -1" class-name="cursor" width="200">-->
<!--            <template #default="scope">-->
<!--              <UserLog :user-log-list="scope.row.userLogList" />-->
<!--            </template>-->
<!--          </el-table-column>-->
        </el-table>
        <el-pagination background layout="total, prev, pager, next, jumper" :total="totalRow" :page-size="pageSize" :current-page="currentPage" @current-change="handleCurrentChange">
        </el-pagination>
        <el-dialog v-model="showUploadDialog" title="确认上传以下图片" width="660px" @close="cancelUpload">
          <el-space wrap>
            <div v-for="(item, index) in imgArray" :key="item.id" class="imgItem">
              <el-image style="width: 60px; height: 60px" fit="cover"  :src="item.img_small" @click="showUploadImg(index, imgArray)" class="cursor"></el-image>
              <div class="closeBtn" @click="delUploadImg(index)">
                <i class="fa fa-times" aria-hidden="true"></i>
              </div>
            </div>
          </el-space>
          <template #footer>
            <span class="dialog-footer">
              <el-button @click="cancelUpload">Cancel</el-button>
              <el-button type="primary" @click="submitUpload" v-loading="subLoading">Confirm</el-button>
            </span>
          </template>
        </el-dialog>
      </div>
    </div>
  </div>
</template>

<script>
import DatePickerRange from '../../components/DatePickerRange'
import SearchComponents from '../../components/SearchComponents'
import BtnGroup from '../../components/BtnGroup'
import ImgViewer from '../../assets/js/imageViewer'
import {
  getMiaiPageList, exportMiaiExcel, updateMiaiState, uploadMiaiImg,delMiaiImg
} from '../../api/url'
import { getFormData, postJson, postFormData, imgPostFormData } from '../../api/api'
import Dialog from "@/assets/js/dialog";
import UserLogDialog from "@/components/UserLog/UserLogDialog";
import UserLog from "@/components/UserLog/UserLog";
import remarkDialog from "@/views/third/components/remarkDialog";

export default {
  name: "ThirdBlindDate",
  components: { DatePickerRange, SearchComponents, BtnGroup, UserLog },
  data() {
    return {

      sexArray: [
        {label: '不限', value: -1},
        {label: '男', value: 1},
        {label: '女', value: 2},
      ],
      sex: -1,

      // 状态
      stateArray: [
        {label: '不限', value: -1},
        {label: '待审核', value: 1},
        {label: '已通过', value: 2},
        {label: '未通过', value: 3}
      ],
      state: -1,

      educationColumns: [
        {label: '初中', value: 1},
        {label: '中专/职高/技校', value: 2},
        {label: '高中', value: 3},
        {label: '大专', value: 4},
        {label: '本科', value: 5},
        {label: '硕士', value: 6},
        {label: '博士', value: 7}
      ],

      jobStateColumns: [
        {label: '待业', value: 1},
        {label: '上班', value: 2},
        {label: '自己创业', value: 3},
        {label: '退休', value: 4},
      ],

      //时间
      startTime: '',
      endTime: '',
      isChecked: true,


      //搜索
      searchType: '',
      searchValue: '',

      //刷新组
      colList: ['提交时间', '用户信息','手机号','微信号', '教育背景', '工作地', '出生地', '照片', '父母情况', '参加亲属', '状态', '备注'],
      checkColList: [],

      pageDataList: [],
      currentPage: 1,
      totalRow: 0,
      pageSize: 20,

      listLoading: false,
      searchLoading: false,
      bitchPassLoading: false,
      bitchRejectLoading: false,
      bitchSetLoading: false,
      bitchUnsetLoading: false,
      excelLoading: false,


      idArray: [],


      imgArray: [],
      imgNum: '',
      uploadId: '',
      showUploadDialog: false,
      subLoading: false,

    }
  },
  methods: {

    //分页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getPage();
    },

    getTime(val) {
      this.startTime = val[0];
      this.endTime = val[1];
      // console.log(val)
    },

    getCheck(val) {
      this.isChecked = val
    },

    // getExpireTime(val) {
    //   this.startExpire = val[0];
    //   this.endExpire = val[1];
    //   // console.log(val)
    // },
    //
    // getExpireCheck(val) {
    //   this.isExpireChecked = val
    // },

    getSearchType(e) {
      this.searchType = e;
      // console.log(e)
    },
    getSearchValue(e) {
      this.searchValue = e;
      // console.log(e)
    },
    // 展示表格的列
    colListChange(val) {
      this.checkColList = val;
    },
    // 重置参数
    refreshParam() {
      this.isChecked = true;
      this.state = -1;
      this.sex = -1;
      setTimeout(()=> {
        this.getPage(true);
      }, 500)
    },

    //获取选中id
    selsChange(sels) {
      this.idArray = sels.map(item => item.id);
    },

    //全选
    selsAll(column, event) {
      if(column.type == 'selection') {
        let array = this.idArray;
        if(array.length == this.pageDataList.length) {
          array = [];
        }
        this.pageDataList.forEach(item => {
          if(array.indexOf(item.id) === -1) {
            this.$refs.multipleTableRef.toggleRowSelection(item);
          }
        })
      }
    },

    getPage(reset) {
      if(isNaN(this.currentPage)) {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请提交正确的页码',
          type: 'warning'
        })
      } else {
        if(reset) {
          this.currentPage = 1;
        }
        this.searchLoading = true;
        this.listLoading = true;
        this.sendPageReq(this.getPageParam(this.currentPage));
      }
    },

    //页面参数
    getPageParam(page) {
      let param = {};
      param['pageNum'] = page;
      param['state'] = this.state;
      param['sex'] = this.sex;
      param['startTime'] = this.startTime;
      param['endTime'] = this.endTime;
      param['type'] = 1;
      this.pageParam = param;
      return param;
    },
    // 发送页面列表请求
    sendPageReq(param) {
      getFormData(getMiaiPageList, param).then((data) => {
        let {msg, code } = data;
        if(code == 200) {
          let result = data['data'];
          this.pageDataList = result['records'];
          this.totalRow = result['total'];
          this.pageSize = result['size'];
        }else{
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
        this.searchLoading = false;
        this.listLoading = false;
      })
          .catch((response) => {
            this.searchLoading = false;
            this.listLoading = false;
          })
    },

    toggleSelection(row, column, cell, event) {
      if(column.type == 'selection') {
        this.$refs.multipleTableRef.toggleRowSelection(row)
      }
      //更新用户日志
      // if(column.label == '用户日志') {
      //   Dialog.open({
      //     title: '用户日志',
      //     component: UserLogDialog,
      //     data: {
      //       id: row.userId
      //     },
      //     close: () => {
      //       row['userLogList'] = JSON.parse(sessionStorage.getItem('userLog'));
      //     }
      //   })
      // }

      if(column.label == '备注') {
        Dialog.open({
          title: '编辑用户备注',
          component: remarkDialog,
          data: {
            id: row.id,
            remark: row.remark,
            width: '500px'
          },
          confirm: (result) => {
            row.remark = result.remark
          }
        })
      }

    },

    showImg(idx, list) {
      let imgList = []
      for(let i=0; i< list.length; i++) {
        imgList.push(list[i].img)
      }
      ImgViewer.open({
        imgList,
        imgIndex: idx
      })
    },


    batchUpdate(state) {
      if(this.idArray.length > 0) {
        this.$confirm('确认批量'+ (state == 2?'【通过】':'【不通过】') +'选中用户').then(()=>{
          if(state == 1) {
            this.bitchPassLoading = true;
          }else {
            this.bitchRejectLoading = true;
          }
          let _this = this;
          let param = {};
          param['idArr'] = this.idArray
          param['state'] = state
          postFormData(updateMiaiState, param).then((data) => {
            let {code, msg} = data;
            if(code == 200) {
              _this.$message({
                showClose: true,
                duration: 1000,
                message: msg,
                type: 'success'
              });
              for(let j=0;j<_this.idArray.length;j++){
                for(let i=0;i<_this.pageDataList.length;i++) {
                  if(_this.pageDataList[i]['id'] == _this.idArray[j]) {
                    _this.pageDataList.splice(i,1);
                    i--;
                  }
                }
              }
              if(_this.pageDataList.length == 0){
                _this.getPage();
              }
            }else {
              _this.$message({
                showClose: true,
                duration: 1000,
                message: msg,
                type: 'warning'
              });
            }
            _this.bitchPassLoading = false;
            _this.bitchRejectLoading = false;
          })
              .catch(()=>{
                _this.bitchPassLoading = false;
                _this.bitchRejectLoading = false;
              })
        })
      } else {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请至少选择一个用户进行操作',
          type: 'warning'
        })
      }
    },


    // 导出数据
    excel() {
      if (this.idArray.length == 0) {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请至少选择一项进行操作',
          type: 'warning'
        });
      } else {
        let url = HOST + exportMiaiExcel + '?idArr=' + this.idArray;
        window.location.href = url;
      }
    },


    showUploadImg(idx, list) {
      let imgList = []
      for(let i=0; i< list.length; i++) {
        imgList.push(list[i].img)
      }
      ImgViewer.open({
        imgList,
        imgIndex: idx
      })
    },

    delImg(id, rowIndex, index) {
      let _this = this;
      this.$confirm('确定要删除图片？', {type: 'warning'}).then(() => {
        let param = {};
        param['id'] = id;
        postFormData(delMiaiImg, param).then((data) => {
          let {code, msg} = data;
          if (code == 200) {
            _this.pageDataList[rowIndex]['imgList'].splice(index, 1);
            _this.$message({
              showClose: true,
              duration: 1000,
              message: msg,
              type: 'success'
            })
          } else {
            _this.$message({
              showClose: true,
              duration: 1000,
              message: msg,
              type: 'warning'
            })
          }
        })
      }).catch(() => {
      })
    },

    //添加图片
    addImg(row) {
      this.imgNum = row.imgList.length;
      this.uploadId = row.id;
      this.$refs.file.click();
    },

    delUploadImg(idx) {
      this.imgArray.splice(idx,1);
    },

    cancelUpload() {
      this.showUploadDialog = false;
      this.imgArray = [];
    },

    //选取图片
    fileChanged(e) {
      if(e.target.files[0]) {
        if((e.target.files.length + this.imgNum) > 9) {
          this.$message({
            showClose: true,
            duration: 2000,
            message: '上传图片不能超过9张',
            type: 'warning'
          })
          return false
        }
        for(let item of e.target.files) {
          let windowURL = window.URL || window.webkitURL;
          let src = windowURL.createObjectURL(item);
          let obj = {'img': src, 'img_small': src, 'files': item};
          this.imgArray.push(obj);
        }
      }
      this.showUploadDialog = true
    },

    submitUpload() {
      this.subLoading = true;
      let param = new FormData();
      param.append('id', this.uploadId);
      for(let i = 0; i < this.imgArray.length; i++) {
        param.append('files' + i, this.imgArray[i].files);
      }
      imgPostFormData(uploadMiaiImg, param).then((data) => {
        let {msg, code} = data
        if (code == 200) {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'success'
          });
          this.getPage()
        }else {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'warning'
          });
        }
        this.subLoading = false
        this.showUploadDialog = false;
        this.imgArray = [];
      })
    },

  },
  mounted() {
    this.$nextTick(function() {
      this.checkColList = this.colList;
    })
    this.getPage();
  }
}
</script>

<style scoped>
.imgItem {
  position: relative;
}
.closeBtn {
  width: 2em;
  height: 2em;
  background-color: rgba(0,0,0,0.8);
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  right: 0;
  top: 0;
  font-size: 0.6em;
}
</style>
